import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const sup: SugarElementInfo = { name: "sup", availableChildren: { type: AvailableChildrenType.Any } };
